import SocketProcessingAdapterFactory from './SocketProcessingAdapterFactory';
import { ISocketProcessingAdapterFactoryMethod as ISocketProcessingAdapterFactory } from './interfaces';
import { DIUploadTypes } from '../../types';

export const { SocketProcessingAdapter } = DIUploadTypes;

export type { ISocketProcessingAdapterFactory };

export default SocketProcessingAdapterFactory;
